import Env from '../../util/env';
import {
	API_RESOURCES,
	createApiCreateAction,
	createApiReadAction,
	createApiUpdateAction,
	HTTP_REQUEST_METHODS
} from '../../util/api';
import * as types from '../actiontypes';

export function getKnowledgeForms({
	countryId,
	languageId,
	subServiceLineId,
	digital,
	complex,
	listed,
	groupAudit,
	pcaobfs,
	pcaobia,
	isNotAvailableForSelection,
	clientYearEndDate
}) {
	return createApiReadAction(
		types.GET_ALL_KNOWLEDGE_FORM,
		{
			[API_RESOURCES.KNOWLEDGEFORMTYPES]: undefined
		},
		{
			countryId,
			languageId,
			subServiceLineId,
			digital,
			complex,
			listed,
			groupAudit,
			pcaobfs,
			pcaobia,
			isNotAvailableForSelection,
			clientYearEndDate
		}
	);
}

export function importDocument(engagementId, data) {
	const url = Env.getDocServiceUrl('documentimports.json');

	return {
		type: types.IMPORT_DOCUMENT,
		meta: {
			api: {
				url,
				method: 'POST',
				headers: {
					engagementId
				},
				data
			}
		},
		resolve: true
	};
}

export function createFormProfile(payload, params) {
	return createApiCreateAction(
		types.CREATE_FORM_PROFILE,
		{
			[API_RESOURCES.ENGAGEMENTS]: params.engagementId,
			[API_RESOURCES.FORMS.FORMS]: params.id,
			[API_RESOURCES.FORMS.FORMPROFILE]: undefined
		},
		payload
	);
}

export function patchDocument(engagementId, documentId, data) {
	const url = Env.getDocServiceUrl(`documents.json/${documentId}`);

	return {
		type: types.DOCSERVICE_DOCUMENT_PATCH,
		meta: {
			api: {
				url,
				method: 'PATCH',
				headers: {
					engagementId,
					'patch-metadata': true
				},
				data
			}
		}
	};
}

export function updateContent(engagementId, payload) {
	return createApiUpdateAction(
		types.UPDATE_CONTENT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTENTS]: undefined
		},
		payload
	);
}
